import api from '@/services/api.js';
import Portfolio from '@/models/Portfolio.js';
import qs from 'qs';

export default {
    getOne(portfolioId){
        return api.get('/portfolios/' + portfolioId); 
    },
    create(userId){
        return api.post('portfolios/', new Portfolio(userId));
    },
    update(portfolio){
        return api.put('/portfolios/' + portfolio.id, portfolio);
    },
    updateById(id, portfolio){
        return api.put('/portfolios/' + id, portfolio);
    },
    getMany(idArray){
        if(!idArray)
            return;
        
        const query = qs.stringify({ _where: { id_in: idArray } });
        return api.get(`/portfolios?${query}`);
    },
    async getOwnedCount(userId){
        if(!userId)
            return;
        
        return (await api.get(`/portfolios/count?owner.id=${userId}`)).data;
    },
    async getOneByArticleId(articleId){
        const query = qs.stringify({ _where: { 'articles.id': articleId } });
        return await api.get(`/portfolios?${query}`);
    },
    async getOneByContactId(contactId){
        const query = qs.stringify({ _where: { 'contacts.id': contactId } });
        return await api.get(`/portfolios?${query}`);
    }
}